module.exports = __webpack_public_path__ + "img/Logo_SPDATA_horizontal_collor-228x65.168f902d.png";